<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="130px">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="标题/用户姓名"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.keyword"
                  placeholder="请输入标题/用户姓名进行检索"
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="title" label="共议标题" align="center">
        </el-table-column>
        <el-table-column prop="content" label="共议内容" align="center" show-overflow-tooltip="">
        </el-table-column>
        <el-table-column prop="userName" label="用户姓名" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="用户联系电话" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间" align="center">
        </el-table-column>      
        <el-table-column prop="status" label="审核状态" align="center" width="120px">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">审核通过</el-tag>
            <el-tag v-if="scope.row.status == -1" type="danger">审核未通过</el-tag>
            <el-tag v-if="scope.row.status == 0">待审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.status == 0" size="small" @click="onReview(scope.row)"
              >去审核</el-button
            >
            <el-button type="text" size="small" @click="seeDetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
       
      </div>
      <!-- 新增模态框 -->
      <el-dialog
        :title="diaTitle"
        :visible.sync="isAddModals"
        width="50%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="120px"
          :rules="addDataRules"
          id="printTest"
          label-position="left"
          style="margin: 0 20px;"
        >
          <el-form-item label="活动标题：">
            <div>{{ addData.title }}</div>
          </el-form-item>
          <el-form-item label="提案内容：">
            <div>{{ addData.content }}</div>
          </el-form-item>
          <el-form-item label="上传的图片：">
            <div v-if="addData.img">
              <el-image style="width: 100px;height: 100px;margin: 0 10px 10px 0;" fit="cover" :src="item" v-for="(item,i) in addData.img.split(',')" :preview-src-list="addData.img.split(',')"></el-image>
            </div>
          </el-form-item>
          <el-form-item label="用户姓名：">
            {{ addData.userName }}
          </el-form-item>
          <el-form-item label="联系电话：">
            {{ addData.phone }}
          </el-form-item>
          <el-form-item label="提交时间：">
            {{ addData.createTime }}
          </el-form-item>
          <el-form-item label="审核结果：" v-if="addData.status != 0">
            {{ addData.status == 1?'审核通过':addData.status == -1?'审核未通过':'待审核' }}
          </el-form-item>
          <el-form-item label="原因说明：" v-if="addData.status == -1">
            {{ addData.verifyDes }}
          </el-form-item>
          <el-form-item label="审核时间：" v-if="addData.status != 0">
            {{ addData.verifyTime }}
          </el-form-item>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isAddModals = false">关闭</el-button>
          </span>
        </el-form>
        
      </el-dialog>

     
      <el-dialog 
        :title="diaTitle"
        :visible.sync="isAddModal"
        width="50%"
        :close-on-click-modal="false">
        <el-form
          ref="form"
          :model="addData"
          label-width="120px"
          :rules="addDataRules"
          id="printTest"
          label-position="left"
          style="margin: 0 20px;"
        >
          <el-form-item label="审核结果" prop="verifyStatus">
            <el-radio-group v-model="addData.verifyStatus">
              <el-radio :label="1">审核通过</el-radio>
              <el-radio :label="-1">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="原因说明" v-if="addData.verifyStatus == -1" prop="verifyDes">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入原因说明"
              maxlength="500"
              show-word-limit
              v-model="addData.verifyDes">
            </el-input>
          </el-form-item>
          
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="compleClick" :loading="btnLoading">确 定</el-button>
          <el-button @click="isAddModal = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      isAddModal: false,
      btnLoading: false,
      isAddModals: false,
      personList: [],
      addData: {
        manageUserId:"",
        subscribeTime:"",
        verifyDes:'',
        verifyStatus:''
      },
      addDataRules: {
        verifyStatus: [{ required: true, message: "请选择审核结果", trigger: "change" }],
        verifyDes: [{ required: true, message: "请输入原因说明", trigger: "blur" }],
      },
      personList: [],
      searchForm: {
      },
      diaTitle:'详情'
      
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    seeDetail(row) {
      this.$Apis.proposalDetail({
        id:row.id
      }).then(res=>{
        if(res.code == 200){
          this.addData = res.data
          this.diaTitle = '详情'
          this.isAddModals = true;
          
        }
      })
     
    },
    onReview(row) {
      this.isAddModal = true;
      this.$nextTick(() => { 
        this.$refs.form.resetFields();
      })
      // this.addData = res.data
      this.addData.id = row.id

      this.addData.verifyStatus = ''
      this.addData.verifyDes = ''
      this.diaTitle = '去审核'
    },
    onLoad(ind) {
      this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
        type:2
      };
      this.tableData = [];
      this.$Apis.proposalGetList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
      
    },
    compleClick(){
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          this.$Apis.proposalVerify({
            id:this.addData.id,
            verifyStatus:this.addData.verifyStatus,
            verifyDes:this.addData.verifyDes
          }).then(res=>{
            this.btnLoading = false
            if(res.code == 200){
              this.isAddModal = false
              this.$message.success('操作成功')
              this.onLoad()
            }else{
              this.$message.warning(res.msg)
            }
          })
        }
      });
      
    },
  },
};
</script>

<style  scoped>
/deep/.el-input.is-disabled .el-input__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
.flex{
  display: flex;
  align-items: center;
  height: 40px;
}
.main{
  padding-top: 30px;
  border-top: 1px solid #eee;
}
.mtitle{
  font-size: 18px;
  /* padding-left: 40px; */
  font-weight: bold;

}
.dialog-footer{
  display: flex;
  justify-content: center;
}
</style>